// extracted by mini-css-extract-plugin
export var content = "FFFErrorBoundary_content__-4hzt";
export var errorPage = "FFFErrorBoundary_errorPage__ULQcJ";
export var imageWrapper = "FFFErrorBoundary_imageWrapper__tYExV";
export var lg = "992px";
export var md = "768px";
export var separator = "FFFErrorBoundary_separator__WinKL";
export var shared = "'../shared.module.css'";